module.exports = __webpack_public_path__ + "static/media/1POLICY38.94ff73c1.jpg";